export default __webpack_public_path__ + "static/media/search_icon.84d5670d.svg";